import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Grid, Typography } from "@mui/material";
import withStyles from "@mui/styles/withStyles";
import { numberFormat } from "../../extends/NumberFormat";
import PopoverButton from "../PopoverButton/PopoverButton";
import { sections } from "../../hooks/useEventComments";

const styles = (theme) => ({
  font: {
    fontWeight: "bold",
  },
  redColor: {
    color: "red",
  },
  hrUnderline: {
    borderBottom: "1px solid black",
  },
  hrDoubleUnderline: {
    borderBottom: "double",
  },
  subTotal: {
    // textAlign: "right",
    marginRight: 10,
  },
  border: {
    border: "1px solid #F6F6F9",
    borderRadius: 10,
    background: "#F6F6F9",
    padding: 13,
    marginBottom: 20,
  },
  break: {
    display: "flex",
    justifyContent: "flex-end",
    [theme.breakpoints.down("sm")]: {
      order: 1,
      justifyContent: "flex-start",
      marginTop: 10,
    },
  },
});

const EventFinancials = (props) => {
  const { classes, event, pastEvent } = props;

  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    event.lineItems.map((element, index) => {
      if (element.type === "subtotal")
        event.lineItems[index - 1].displayLine = true;
      else if (element.type === "total")
        event.lineItems[index - 1].displayLine = false;

      setLoaded(true);
      return event;
    });
  }, [event]);
  return loaded ? (
    <Grid container className={classes.border}>
      <Grid item xs={12} sm={10}>
        <Grid container>
          {event.lineItems.map((item, index) => {
            return (
              <React.Fragment key={index}>
                <Grid item xs={7} sm={5} md={3}>
                  <Typography
                    variant="subtitle1"
                    className={
                      ["subtotal", "total"].includes(item.type)
                        ? classes.subTotal
                        : null
                    }
                  >
                    <span className={classes.font}>{item.name}: </span>
                  </Typography>
                </Grid>
                <Grid item xs={5} sm={7} md={9}>
                  <Typography
                    variant="subtitle1"
                    className={
                      item.total < 0 ||
                      ["discount", "payment"].includes(item.type)
                        ? classes.redColor
                        : null
                    }
                  >
                    {item.total < 0 ||
                    ["discount", "payment"].includes(item.type)
                      ? `(${numberFormat(Math.abs(item.total))})`
                      : numberFormat(item.total)}
                  </Typography>

                  {item.hasOwnProperty("displayLine") ? (
                    <Grid container justifyContent="flex-start">
                      <Grid
                        item
                        xs={5}
                        sm={3}
                        md={2}
                        lg={1}
                        className={
                          item.displayLine
                            ? classes.hrUnderline
                            : classes.hrDoubleUnderline
                        }
                      ></Grid>
                    </Grid>
                  ) : null}
                </Grid>
              </React.Fragment>
            );
          })}
        </Grid>
      </Grid>
      {!pastEvent ? (
        <Grid item xs={12} sm={2} className={classes.break}>
          <PopoverButton
            type={event.newComment}
            additionalFieldIds={[sections.financial.paymentFieldId]}
          />
        </Grid>
      ) : null}
    </Grid>
  ) : null;
};

EventFinancials.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(EventFinancials);
